/**
 * Returns 'white' or '#222222' based on which provides better contrast
 * with the given background color (WCAG relative luminance formula).
 */
export function getContrastTextColor(bgColor: string): string {
    const hex = bgColor.replace('#', '');
    const r = parseInt(hex.substring(0, 2), 16) / 255;
    const g = parseInt(hex.substring(2, 4), 16) / 255;
    const b = parseInt(hex.substring(4, 6), 16) / 255;

    const toLinear = (c: number) =>
        c <= 0.03928 ? c / 12.92 : Math.pow((c + 0.055) / 1.055, 2.4);

    const luminance =
        0.2126 * toLinear(r) + 0.7152 * toLinear(g) + 0.0722 * toLinear(b);

    // Use 0.179 threshold (contrast ratio ~4.5:1 with white)
    return luminance > 0.179 ? '#222222' : 'white';
}
